<template>
    <Layout>
        <div slot="main" class="home-bg">
            <nav class="back-nav">
                <div class="strong">{{lang.companyStyle}}</div>
                <div class="back-icon" @click="goBack">
                    <img :src="back" alt="">
                </div>
            </nav>
            <div class="block company-block">
                <dl v-for="(style, index) in styleList" :key="index">
                    <dt class="company-text">{{isCn?style.cnImageName:style.enImageName}}</dt>
                    <dd class="company-photo">
                        <img :src="style.image" alt="">
                    </dd>
                </dl>
                <div class="more-row" v-show="isMore">
                    <span class="btn-more" @click="moreStyle">{{lang.spread}}</span>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import backSrc from '@/style/image/back.png';
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'companyStyle',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            styleList: [],
            page: 1,
            isMore: false,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        getList() {
            this.isMore = false;
            ajax.get('/web/homepage/company_style_list.json', {
                pageSize: 5,
                page: this.page,
            }).then((result) => {
                this.styleList = this.styleList.concat(result.dataList);
                this.page += 1;
                if (result.totalPage > result.page) {
                    this.isMore = true;
                }
            }).catch(() => {});
        },
        moreStyle() {
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F1F1F1;
    }
    .back-nav {
        width: 100%;
        height: 44px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: fixed;
        top: 50px;
        left: 0;
        z-index: 3;
        border-bottom: 1px solid #F1F1F1;
        .back-icon {
            width: 11px;
            height: 17px;
            margin-top: 14px;
            margin-left: 20px;
            z-index: 3;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            font-size: 15px;
            color: #4A4A4A;
            text-align: center;
            line-height: 44px;
            font-weight: 500;
            overflow: hidden;
            padding: 0 50px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px;
    }
    .company-block {
        padding-top: 44px;
        .company-text {
            margin-top: 10px;
            font-size: 13px;
            line-height: 20px;
            padding: 2px 0;
        }
        .company-photo {
            padding-bottom: 12px;
            border-bottom: 1px solid #F1F1F1;
            width: 100%;
            img {
                width: 100%;
            }
        }
    }
    .more-row {
        padding-top: 16px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
</style>
